export default {
  setLoading(state, payload) {
    state.loading = payload
  },
  setDirectory(state, payload) {
    state.directory = payload
  },
  setModalDirectory(state, payload) {
    state.modalDirectory = payload
  },
  setSavedDirectory(state, payload) {
    state.savedDirectory = payload
  },
  setItem(state, payload) {
    state.item = payload
  },
}
